export default "__VITE_ASSET__ee30c613__"